<template>
  <v-card
    class="ma-0 px-1"
    width="100%"
    flat
  >
    <v-app-bar
      flat
      class="my-0 mb-2 py-1 px-4"
      dense
      height="30"
    >
      <v-toolbar-title> {{ $t('processingProductCost') }} </v-toolbar-title>
      <v-spacer />
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-shortkey="['f5']"
            v-bind="attrs"
            icon
            small
            class="float-left"
            @shortkey="getItems"
            v-on="on"
            @click="getItems"
          >
            <v-icon
              color="blue"
              style="font-size: 22px"
            >
              mdi-refresh
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('refresh') }}(f5)</span>
      </v-tooltip>
      <log
        ref="logRef"
        v-if="$store.state.permissions && $store.state.permissions.includes('logList')"
        :type-prop="type"
        mode-prop="button"
      />
      <export-excel
        :data="excelItems"
        worksheet="abriron.com"
        name="data-ai.xls"
        type="xls"
        class="float-left"
        ref="refExcel"
        :title="$store.state.abrName"
        :total-prop="pageCount"
        :page-prop="excelPage"
        @getAllRows="getAllRows"
      >
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              icon
              small
              v-on="on"
            >
              <v-icon
                style="font-size: 22px"
                color="green"
              >
                mdi-file-excel-outline
              </v-icon>
            </v-btn>
          </template>
          <span>{{ $t('excel') }}</span>
        </v-tooltip>
      </export-excel>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            icon
            class="float-left"
            small
            v-on="on"
          >
            <v-icon
              color="primary"
              style="font-size: 22px"
              @click="filter = true"
            >
              mdi-filter-outline
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('filter') }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            icon
            class="float-left"
            small
            v-on="on"
          >
            <v-icon
              color="primary"
              style="font-size: 22px"
              @click="printDialog = true"
            >
              mdi-cloud-print-outline
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('print') }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            icon
            small
            v-on="on"
            @click="$router.go(-1)"
          >
            <v-icon
              color="primary"
              style="font-size: 22px"
            >
              mdi-arrow-left
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('back') }}</span>
      </v-tooltip>
    </v-app-bar>
    <div style="zoom:0.9">
      <v-row class="mt-1 mx-0">
        <v-col
          class="mb-0 pe-0 pb-0 "
          style="height: 55px"
          cols="12"
          md="3"
          sm="3"
        >
          <aicomplete
            ref="refGroup"
            v-model="group"
            :val="group"
            title="main-group"
            type="productGroup"
            :data="JSON.stringify({parent:0,type:'group'})"
            :new-btn="true"
          />
        </v-col>
        <v-col
          class="mb-0 pe-0 pb-0 "
          style="height: 55px"
          cols="12"
          md="3"
          sm="3"
        >
          <aicomplete
            ref="refCat1"
            v-model="cat1"
            :val="cat1"
            title="other-group"
            type="productGroup"
            :data="JSON.stringify({parent:(group?group.id:null),type:'category'})"
            :new-btn="true"
          />
        </v-col>
        <v-col
          class="mb-0 pe-0 pb-0 "
          style="height: 55px"
          cols="12"
          md="3"
          sm="3"
        >
          <aicomplete
            ref="refCat2"
            v-model="cat2"
            :val="cat2"
            title="category"
            type="productGroup"
            :data="JSON.stringify({parent:(cat1?cat1.id:null),type:'subcategory'})"
            :new-btn="true"
          />
        </v-col>
        <v-col
          cols="12"
          md="3"
          class="pe-0"
        >
          <autocomplete
            v-model="product"
            title="product"
            type="product"
            :multiple="false"
            :solo="false"
            :dense="false"
          />
        </v-col>
      </v-row>
      <v-row class="mx-0">
        <v-col
          cols="12"
          md="3"
          class="pe-0"
        >
          <autocomplete
            v-model="account"
            title="account"
            type="person"
            :new-btn="true"
          />
        </v-col>
        <v-col
          cols="12"
          md="3"
          class="pe-0"
        >
          <autocomplete
            v-model="detail"
            title="detail"
            type="detail"
          />
        </v-col>
        <v-col
          cols="12"
          md="3"
          class="pe-0"
        >
          <money
            v-model="amount"
            :label="$t('amount')"
            :dense="true"
            :outlined="true"
            :solo="false"
            :clearable="true"
            value-when-is-empty=""
            :options="options"
          />
        </v-col>
        <v-col
          cols="12"
          md="3"
          class="pe-2"
        >
          <v-btn
            color="green"
            class="mr-0"
            block
            small
            style="height: 31px;"
            :loading="loading"
            @click="create"
          >
            {{ $t('addProcessingCost') }}
          </v-btn>
        </v-col>
      </v-row>
      <v-row class="mx-0 mb-2">
        <v-col
          class="px-2 pt-3 mb-1"
          cols="12"
        >
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            :label="$t('search')"
            solo
            flat
            height="30"
            :background-color="($vuetify.theme.isDark ? '#1E1E1E' : '#e5e5e5')"
            dense
          />
        </v-col>
      </v-row>
      <v-col
        cols="12"
        class="px-2 pt-0 border-datatable"
      >
        <v-data-table
          v-if="headers"
          v-model="selected"
          :height="tableHeight"
          fixed-header
          :headers="showHeaders"
          :items="items"
          :options.sync="options"
          :server-items-length="totalItems"
          :loading="loading"
          multi-sort
          dense
          :show-select="showSelect"
          item-key="id"
          :page.sync="page"
          class="mb-0"
        >
          <template v-slot:item.row="{ item }">
            <div class="px-1">
              {{ parseInt(items.indexOf(item))+ parseInt(from) }}
            </div>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-menu
              offset-y
            >
              <template v-slot:activator="{ attrs, on }">
                <v-btn
                  color="primary"
                  v-bind="attrs"
                  icon
                  v-on="on"
                >
                  <v-icon
                    medium
                  >
                    mdi-dots-vertical
                  </v-icon>
                </v-btn>
              </template>

              <v-list dense>
                <v-list-item
                  link
                  @click="openDeleteDialog(item)"
                >
                  <v-list-item-icon>
                    <v-icon color="pink">
                      mdi-trash-can-outline
                    </v-icon>
                  </v-list-item-icon>
                  <v-list-item-title v-text="$t('remove')" />
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
          <template v-slot:item.amount="{ item }">
            {{ $numberFormat(+item.amount) }}
          </template>
          <template v-slot:footer.prepend>
            <v-col
              v-show="!isMobile"
              cols="1"
              class="pa-0"
              style="margin-top: -10px"
            >
              <v-text-field
                v-model.number="page"
                :label="$t('goToPage')"
                min="1"
                :max="pageCount"
                type="number"
                outlined
                height="32"
                hide-details
                hide-spin-buttons
                dense
                :suffix="'  /  ' + pageCount"
              />
            </v-col>
          </template>
        </v-data-table>
      </v-col>
    </div>
    <v-row />
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="printDialog"
      width="70%"
    >
      <v-card>
        <v-col
          class="d-flex pb-0"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="printDialog = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('print') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <print
            :header-prop="showHeaders"
            :items-prop="items"
            :title="$t($route.name)"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="filter"
      width="70%"
    >
      <v-card>
        <v-col
          class="d-flex"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="filter = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('filter') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <v-col
            cols="12"
            md="4"
          >
            <v-select
              v-model="selectedHeaders"
              :items="headers"
              label="Select Columns"
              height="30"
              dense
              outlined
              multiple
              return-object
            >
              <template v-slot:selection="{ item, index }">
                <v-chip
                  v-if="index < 2"
                  small
                >
                  <span>{{ item.text }}</span>
                </v-chip>
                <v-chip
                  v-if="index === 1"
                  small
                >
                  <span>(+{{ selectedHeaders.length - 2 }} {{ $t('other') }})</span>
                </v-chip>
              </template>
            </v-select>
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <status
              v-model="sellStatus"
              :hideconfig="true"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <tag
              v-model="tag"
            />
          </v-col>
        </v-row>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col cols="6">
              <v-btn
                class=" mx-0"
                color="primary"
                @click="getItems"
              >
                {{ $t('filter') }}
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                color="grey"
                outlined
                class="float-left mx-0"
                @click="filter = false"
              >
                {{ $t('cancel') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="taskDialog"
      width="90%"
    >
      <v-card>
        <v-col
          class="d-flex"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="taskDialog = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('task') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <task
            task-type="account"
            :ref-id="refId"
            :task-id="taskId"
            @close="taskDialog = false"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="deletDialog"
      width="400"
    >
      <v-card>
        <v-col>
          <v-btn
            icon
            class="close-hover"
            @click="deletDialog = false"
          >
            <v-icon
              color="grey"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
        </v-col>
        <v-col>
          <v-img
            class="mx-auto"
            width="200"
            src="@/assets/stop.svg"
          />
        </v-col>
        <v-col
          class="mt-3 pr-7"
        >
          <p class="mx-auto font-weight-medium">
            {{ $t('are-you-sure-delete-this-case') }}
          </p>
        </v-col>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col cols="6">
              <v-btn
                v-if="selected.length > 0"
                color="primary"
                @click="removegroup"
              >
                {{ $t('remove') }}
              </v-btn>
              <v-btn
                v-if="selected.length == 0"
                color="primary"
                @click="remove"
              >
                {{ $t('remove') }}
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                color="grey"
                outlined
                class="float-left"
                @click="deletDialog = false"
              >
                {{ $t('cancel') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <snakbar
      v-model="snakbar"
      :text="snakbarText"
      :active="snakbar"
      :color="snakbarColor"
    />
  </v-card>
</template>

<script>
  import Task from '../task/task'
  import Print from '../../components/general/Print/Index'
  import General from '../../../../Mixins/general'
  import autocomplete from '../../components/general/patial/autocomplete'
  export default {
    name: 'Review',
    components: {
      Snakbar: () => import('../../components/general/snakbar/snakbar'),
      Tag: () => import('../../components/general/Tag/tag'),
      Status: () => import('../../components/general/Status/status'),
      Print,
      autocomplete,
      Task,
    },
    mixins: [General],
    props: ['input', 'refId', 'accountProp'],
    data: () => ({
      excelItems: [],
      selected: [],
      pageCount: 1,
      page: 1,
      filterType: 'month',
      filterTypeItems: null,
      account: null,
      amount: null,
      cat1: null,
      cat2: null,
      fromFinancialYear: null,
      toFinancialYear: null,
      documentType: null,
      remain: 'debtorCreditor',
      remainItems: [],
      detail: null,
      fromMonthItems: null,
      toMonthItems: null,
      toMonth: null,
      fromDate: null,
      toDate: null,
      printDialog: false,
      deletDialog: false,
      showSelect: false,
      filter: false,
      level: 'group',
      productStatus: null,
      productStatusItems: null,
      model: null,
      from: 1,
      taskDialog: null,
      tag: null,
      levelItems: ['group', 'total', 'given', 'detail'],
      temp: null,
      deleteItem: null,
      sellStatus: null,
      items: [],
      sortBy: [],
      dialog: null,
      timer: 0,
      totalItems: 0,
      snakbar: false,
      total: null,
      group: null,
      typeForm: null,
      product: null,
      taskId: null,
      snakbarText: null,
      loading: true,
      options: {
        itemsPerPage: 5,
      },
      headers: null,
      type: null,
      search: null,
      selectedHeaders: [],
      headersMap: null,
      fin4: null,
      given: null,
    }),
    computed: {
      isMobile () {
        return this.$vuetify.breakpoint.name === 'xs'
      },
      showHeaders () {
        var app = this
        return this.headers.filter(function (s) {
          if (app.accountProp) {
            if (s.value === 'fin4.name' || s.value === 'given.name') {
            } else {
              return app.selectedHeaders.includes(s)
            }
          } else {
            return app.selectedHeaders.includes(s)
          }
        })
      },
    },
    watch: {
      level (val, oldVal) {
        if (val === 'back') {
          this.backLevel(oldVal)
        } else {
          this.getItems()
        }
      },
      refId (val, oldVal) {
        // this.items = []
        this.getItems()
      },
      model () {
        this.$emit('input', this.model)
      },
      selected () {
        this.$emit('input', this.selected.text)
        if (this.selected.length > 0) {
          this.model = this.selected[0].text
          this.temp = this.selected[0].text
        }
        this.dialog = false
      },
      search () {
        var app = this
        app.loading = true
        app.page = 1
        clearTimeout(this.timer)
        this.timer = setTimeout(function () {
          app.getItems()
        }, 1000)
      },
      options: {
        handler () {
          var app = this
          app.sortBy = []
          app.options.sortBy.map(function (value, key) {
            const index = app.headers.findIndex(h => h.value === value)
            app.sortBy.push(app.headers[index].table)
          })
          this.getItems()
        },
        deep: true,
      },
      sortBy () {
        const index = this.headers.findIndex(h => h.value === this.sortBy)
        if (index > -1) {
          this.sortBy = this.headers[index].table
        }
      },
      group (Val, oldVal) {
        if (this.$refs.refCat2 && this.$refs.refCat1) {
          if (Val) {
            this.$refs.refCat1.clear()
            this.$refs.refCat2.clear()
            this.$refs.refCat1.initList = false
            this.$refs.refCat1.getItems()
          } else {
            this.$refs.refCat1.clear()
            this.$refs.refCat2.clear()
          }
        }
      },
      cat1 (Val, oldVal) {
        if (this.$refs.refCat2) {
          if (Val) {
            this.$refs.refCat2.clear()
            this.$refs.refCat2.initList = false
            this.$refs.refCat2.getItems()
          } else {
            this.$refs.refCat2.clear()
          }
        }
      },
    },
    activated () {
    // this.getItems()
    },
    beforeMount () {
      if (this.$route.name === 'review') {
        this.type = 'review'
      }
      if (this.$route.name === 'profit&cost') {
        this.type = 'profit&cost'
      }
      this.headers = [
        {
          text: this.$t('actions'),
          align: 'start',
          sortable: false,
          value: 'actions',
          width: 20,
        },
        {
          text: this.$t('row'),
          align: 'start',
          sortable: false,
          value: 'row',
          width: 20,
        },
        {
          text: this.$t('group'),
          sortable: false,
          value: 'group.name',
          width: 150,
        },
        {
          text: this.$t('other-group'),
          sortable: false,
          value: 'cat1.name',
          width: 150,
        },
        {
          text: this.$t('category'),
          sortable: false,
          value: 'cat2.name',
          width: 100,
        },
        {
          text: this.$t('product'),
          sortable: false,
          value: 'product.name',
          width: 500,
        },
        {
          text: this.$t('details'),
          sortable: false,
          value: 'detail.name',
          width: 100,
        },
        {
          text: this.$t('account'),
          sortable: false,
          value: 'account.name',
          width: 100,
        },
        {
          text: this.$t('amount'),
          sortable: false,
          value: 'amount',
          width: 100,
        },
      ]
      this.headersMap = this.headers
      this.selectedHeaders = this.headers
      if (this.fin4Prop) {
      // const selectedHeaders = app.headers.findIndex(h => h.value === value)
      }
      this.productStatusItems = [
        {
          value: 'active',
          text: this.$t('active'),
        },
        {
          value: 'deactive',
          text: this.$t('deactive'),
        },
      ]
      if (this.input) {
        this.model = this.input
      }
      this.remainItems = [
        {
          value: 'debtorCreditor',
          text: this.$t('debtor') + ' ' + this.$t('creditor'),
        },
        {
          value: 'debtor',
          text: this.$t('debtor'),
        },
        {
          value: 'creditor',
          text: this.$t('creditor'),
        },
        {
          value: 'zero',
          text: this.$t('zero'),
        },
      ]
      this.filterTypeItems = [
        {
          value: 'month',
          text: this.$t('month'),
        },
        {
          value: 'date',
          text: this.$t('date'),
        },
      ]
    },
    mounted () {
      this.fromFinancialYear = this.$store.state.financialYear
      this.toFinancialYear = this.$store.state.financialYear
      // this.getItems()
    },
    methods: {
      setLevel (item) {
        switch (this.level) {
          case 'group':
            this.level = 'total'
            this.group = [{ id: item.groupId, name: item.groupName }]
            break
          case 'total':
            this.level = 'given'
            this.total = [{ id: item.totalId, name: item.totalName }]
            break
          case 'given':
            this.level = 'detail'
            this.given = [{ id: item.givenId, name: item.givenName }]
            break
          case 'detail':
            this.level = 'detail'
            // this.fin4 = [{ id: item.fin4_id, name: (item.fin4 ? item.fin4.name : '') }]
            break
          default:
            this.level = 'detail'
        }
        if (this.level === 'detail') {
          this.turnover(item)
        }
      // this.getItems()
      },
      backLevel (level) {
        if (level === 'group') {
          this.level = 'group'
        }
        if (level === 'total') {
          this.group = null
          this.level = 'group'
        }
        if (level === 'given') {
          this.total = null
          this.level = 'total'
        }
        if (level === 'detail') {
          this.given = null
          this.level = 'given'
        }
        if (level === 'turnover') {
          this.level = 'detail'
          this.fin4 = null
        }
      },
      openDeleteDialog (item) {
        this.deleteItem = item
        this.deletDialog = true
      },
      openTaskDialog (item) {
        this.refId = item.rel_id
        this.taskId = item.id
        this.taskDialog = true
      },
      isEnabled (slot) {
        return this.enabled === slot
      },
      edit (item) {
        this.$router.push({ name: 'accountingEdit', params: { id: item.head_id } })
      },
      create () {
        var app = this
        app.loading = true
        // var formData = new FormData()
        // formData.append('contraryItems', JSON.stringify(this.items))
        app.$axios.post(this.$endpoint + 'productsProcessing', this.$data)
          .then(res => {
            app.snakbarText = app.$t('documentRegisterd')
            app.snakbarColor = 'green'
            app.snakbar = true
            app.getItems()
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => {
            this.loading = false
          })
      },
      getItems () {
        var app = this
        app.loading = true
        app.$axios.get(this.$endpoint + 'productsProcessing', {
          params: {
            detail: (app.detail ? app.detail.id : null),
            group: (app.group ? app.group.id : null),
            cat1: (app.cat1 ? app.cat1.id : null),
            cat2: (app.cat2 ? app.cat2.id : null),
            product: (app.product ? app.product.id : null),
            sortBy: app.sortBy,
            page: (app.allRows ? app.excelPage : app.options.page),
            options: app.options,
          },
        })
          .then(res => {
            res = res.data
            if (!app.allRows) {
              app.items = res.data
              app.totalItems = res.total
              app.pageCount = res.last_page
              app.from = res.from
              app.creatExcelData(res.data)
            } else {
              app.generateExcellForAllData(res.data, res.last_page)
            }
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(function () {
            app.loading = false
          })
      },
      remove () {
        var app = this
        if (!app.deleteItem) return false
        app.loading = true
        app.$axios.delete(this.$endpoint + 'productsProcessing/' + this.deleteItem.id)
          .then(res => {
            res = res.data
            app.deletDialog = false
            app.deleteItem = null
            app.getItems()
          })
          .catch(err => {
            this.deletDialog = false
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      turnover (item) {
        this.$router.push({ name: 'turnoverDetail', params: { id: item.fin4_id, accountProp: { fin_id: item.fin4_id, name: item.fin4.name }, tabName: item.fin4.name } })
      },
      removegroup () {
        var app = this
        app.loading = true
        app.$axios.get(this.$endpoint + 'productsProcessing', {
          params: {
            deleteItems: app.selected,
          },
        })
          .then(res => {
            res = res.data
            app.deletDialog = false
            app.deleteItem = null
            app.selected = []
            app.getItems()
          })
          .catch(err => {
            this.deletDialog = false
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      creatExcelData (data, type = 'page') {
        var app = this
        if (type === 'page') {
          app.excelItems = []
        }
        data.map(function (d) {
          app.excelItems.push({
            group: (d.group ? d.group.name : null),
            catgeory: (d.cat1 ? d.cat1.name : null),
            subCatgeory: (d.cat2 ? d.cat2.name : null),
            product: (d.product ? d.product.name : null),
            details: (d.detail ? d.detail.name : null),
            amount: d.amount,
          })
        })
      },
    },
  }
</script>
<style  lang="sass">
@import '~vuetify/src/styles/tools/_rtl.sass'
.border-datatable
  .theme--light.v-data-table
    .v-data-table__wrapper
      table
        thead
          tr:last-child
            th
              border-top : 1px solid #e3e3e3 !important
              border-left : 1px solid #e3e3e3 !important
              padding : 0px 8px !important
              background-color: #f5f5f5

  .theme--light.v-data-table
    .v-data-table__wrapper
      table
        thead
          tr:last-child
            th:first-child
              border-right : 1px solid #e3e3e3 !important

  .theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:not(:last-child) > td:not(.v-data-table__mobile-row), .theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:not(:last-child) > th:not(.v-data-table__mobile-row)
    border-left : 1px solid #e3e3e3 !important
    padding : 0px 8px !important
  .theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:not(:last-child) > td:not(.v-data-table__mobile-row):first-child, .theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:not(:last-child) > th:not(.v-data-table__mobile-row)
    border-right : 1px solid #e3e3e3 !important
    padding : 0px 8px !important
  .theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:last-child > td:first-child:not(.v-data-table__mobile-row)
    border-right : 1px solid #e3e3e3 !important
  .theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:last-child > td:last-child:not(.v-data-table__mobile-row)
    border-left : 1px solid #e3e3e3 !important
</style>
